import { useMutation, useQueryClient } from 'react-query';
import queries from '../queries';

const useFloorplanCreate = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ routeId, filename, file }) => {
      return queries.floorplans.create.query({ routeId, filename, file });
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.floorplans.get.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

const useFloorplanDelete = (callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id }) => {
      return queries.floorplans.delete.query(id);
    },
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        queryClient.invalidateQueries(queries.floorplans.get.key);
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useFloorplanCreate,
  useFloorplanDelete,
};
